import React from 'react'
import { connect } from 'react-redux'
import ReactGA from 'react-ga';
import { toggleLanguage } from '../actions/language'

class LanguageButton extends React.Component {

    toggleLang = () => {
        ReactGA.event({
            category: 'User event',
            action: 'Language Toggle',
            label: 'lang'
          });

        this.props.dispatch(toggleLanguage());
    }

    render() {
        return (
            <div className="container">
                <button className="btn btn-primary" onClick={this.toggleLang}>{this.props.strings.LANGUAGE_BUTTON_TITLE}</button>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        language: state.language.language,
        strings: state.language.strings,
    }
};

const ConnectedLanguageButton = connect(
    mapStateToProps,
)(LanguageButton);
export default ConnectedLanguageButton;
